/**
 * 实现同源页面通信功能，目前主要用于切换商户的时候将浏览器的所有同源页面重新刷新，防止出现意外的bug
 * 使用：需要接受通信的页面使用 startListenPageStorage(),  发送消息使用 sendPageMessage()
 * 参考文章: https://segmentfault.com/a/1190000011207317
 * tip: IE的浏览器支持非常的不友好
 */

const reload_key = window.location.href.split('#')[0] + '::page_reload' // 同源页面刷新的key

let bindFunction // 绑定的事件
/**
 * window对象开启监听 storage 事件
 * @param {String} key 需要监听的storgae key值
 * @param {Object} fn 监听到之后需要做的操作的回调事件
 * @returns {*}
 */
export function startListenPageStorage(fn, key = reload_key) {
  if (typeof fn !== 'function') { fn = function() { } }

  bindFunction = e => {
    if (e.key === key) {
      if (!e.newValue) { return } // removeItem同样触发storage事件，此时ev.newValue为空
      fn(JSON.parse(e.newValue))
    }
  }
  window.addEventListener('storage', bindFunction, false)
}

/**
 * 发送消息
 * @param {String} key 通信的key值
 * @param {*} message 发送的消息
 * @returns {*}
 */

export function sendPageMessage(message = '', key = reload_key) {
  localStorage.setItem(key, JSON.stringify(message))
  localStorage.removeItem(key) // 直接删除，不污染localStorage
}

/**
 * 取消监听
 */
export function stopListenPageStorage() {
  window.removeEventListener('storage', bindFunction, false)
}

